import { render, staticRenderFns } from "./CompedTicketingEventBadge.vue?vue&type=template&id=4775a303"
import script from "./CompedTicketingEventBadge.vue?vue&type=script&lang=js"
export * from "./CompedTicketingEventBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports